import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ISharePointLocationList } from "../../../models/auto-generated";

@Injectable({
  providedIn: "root"
})
export class SharePointDocumentLocationsService {
  private getBaseRoute(instanceId: string): string {
    return `/api/configurations/${instanceId}/sharepoint-document-locations`;
  }
  constructor(private http: HttpClient) {}

  get(instanceId: string, limit: number, offset: number, searchTerm: string, entity: string): Observable<ISharePointLocationList> {
    const baseRoute = this.getBaseRoute(instanceId);
    const params = new HttpParams().append("limit", limit.toString()).append("offset", offset.toString()).append("searchTerm", searchTerm).append("entity", entity);
    return this.http.get<ISharePointLocationList>(baseRoute, { params: params });
  }

  count(instanceId: string, search: string, entity: string): Observable<number> {
    const baseRoute = this.getBaseRoute(instanceId);
    const params = new HttpParams().append("searchTerm", search).append("entity", entity);
    return this.http.get<number>(`${baseRoute}/count`, { params: params });
  }

  overwritePermissions(instanceId: string, locations: string[]): Observable<void> {
    const baseRoute = this.getBaseRoute(instanceId);
    return this.http.post<void>(`${baseRoute}/overwrite-permissions`, locations);
  }
}
